import React, { Component } from 'react'
import { Button } from '@material-ui/core'
import cn from 'classnames'
import {
  CAGE_COLOR_UNKNOWN,
  CAGE_COLOR_LEVEL1,
  CAGE_COLOR_LEVEL2,
  CAGE_COLOR_LEVEL3,
  CAGE_COLOR_LEVEL4,
  CAGE_COLOR_LEVELX,
} from 'helpers/slaMonitor'

class CheckboxButtonsField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeRate: '',
    }
  }

  onSetRate = e => {
    const value = e.currentTarget.dataset.rate
    this.setState({ activeRate: value }, () => {
      this.props.onClick(value)
    })
  }

  render() {
    const { activeRate } = this.state

    return (
      <div className="info-form">
        <Button
          variant="contained"
          className={cn(
            'cage-rate-variant',
            activeRate === '1' || !activeRate
              ? CAGE_COLOR_LEVEL1
              : CAGE_COLOR_UNKNOWN,
          )}
          data-rate={1}
          onClick={this.onSetRate}>
          1
        </Button>
        <Button
          variant="contained"
          className={cn(
            'cage-rate-variant',
            activeRate === '2' || !activeRate
              ? CAGE_COLOR_LEVEL2
              : CAGE_COLOR_UNKNOWN,
          )}
          data-rate={2}
          onClick={this.onSetRate}>
          2
        </Button>
        <Button
          variant="contained"
          className={cn(
            'cage-rate-variant',
            activeRate === '3' || !activeRate
              ? CAGE_COLOR_LEVEL3
              : CAGE_COLOR_UNKNOWN,
          )}
          data-rate={3}
          onClick={this.onSetRate}>
          3
        </Button>
        {this.props.withFourRate && (
          <Button
            variant="contained"
            className={cn(
              'cage-rate-variant',
              activeRate === '4' || !activeRate
                ? CAGE_COLOR_LEVEL4
                : CAGE_COLOR_UNKNOWN,
            )}
            data-rate={4}
            onClick={this.onSetRate}>
            4
          </Button>
        )}
        <Button
          variant="contained"
          className={cn(
            'cage-rate-variant',
            activeRate === '5' || !activeRate
              ? CAGE_COLOR_LEVELX
              : CAGE_COLOR_UNKNOWN,
          )}
          data-rate={5}
          onClick={this.onSetRate}>
          X
        </Button>
      </div>
    )
  }
}

export default CheckboxButtonsField
